<template>
    <div class="modal fade quote-popup vendormodal" id="sendToVendorModal" ref="sendToVendorModal">
        <div class="modal-dialog" >
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Send To vendor </h5>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body" v-if="quotationData !=null">
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{ errorMessage }}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div class="custom-slect-drop">
                        <div class="form-group">
                            <v-select label="text" :filterable="false" :multiple="true"
                                      v-model="form.vendors"
                                      :options="vendors"
                                      @search="onVendorSearch"
                                      @input="onVendorSelect"
                                      @selected="onVendorSelect"
                                      @deselected ="onVendorDeSelect">
                                <template slot="no-options">
                                    type to search vendors..
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center" v-html="option.html">
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center" v-html="option.text">
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <a class="pull-left addcc-btn" v-if="!isCC" v-on:click="isCC=true"><span class="lt-bl-bg spc-top">Add CC</span></a>
                                <a class="pull-left removecc-btn" v-if="isCC" v-on:click="isCC=false; form.add_cc = []"><span class="lt-bl-bg spc-top">Remove CC</span></a>
                            </div>
                            <div class="col-md-6">
                                <!--<router-link :to="{ name: 'addVendor'}" target="_blank" class="float-right new-vendor">
                                    <i class="fa fa-plus" aria-hidden="true"></i> New Vendor
                                </router-link>-->
                                <a href="javascript:void(0)" data-toggle="modal" data-target="#vendorAddModal" class="float-right new-vendor">New Vendor</a>
                            </div>
                        </div>
                    </div>

                    <!--<input v-if="isCC" type="text" class="order-desc" id="add_cc" v-model="form.add_cc" placeholder="Please enter CC Email Address">-->
                    <!--<InputTag v-if="isCC" v-model="form.add_cc" placeholder="Comma separated CC email addresses"
                              :add-tag-on-blur="true"
                              validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                    ></InputTag>-->
                    <v-select v-if="isCC" label="text" :filterable="false" :multiple="true" :taggable="true" :selectOnTab="true"
                              v-model="form.add_ccSystemUsers"
                              :options="systemUsers"
                              @search="onSystemUserSearch"
                              @input="onSystemUserSelect"
                              @selected="onSystemUserSelect"
                              @deselected ="onSystemUserDeSelect">
                        <template slot="no-options">
                            type to search vendors..
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center" v-html="option.html">
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center" v-html="option.html ? option.html : option.text">
                            </div>
                        </template>
                    </v-select>

                    <input type="text" class="order-desc" id="quote_subject" v-model="form.quote_subject">
                    <div class="vendor-name">
                        <!-- <b>#Vendor Name,</b> -->
                        <ckeditor v-model="form.message_body"
                                  tag-name="textarea"
                                  value="Hello, <p>Please quote the below products</p>"
                                  :config="editorConfigMin"></ckeditor>
                    </div>
                    <div class="table-responsive product-create prod-detials">
                        <table class="table table-custom table-hover">
                            <tbody id="product_list_data">
                            <template v-if="quote_products && quote_products.products.length">
                                <template v-for="(item, index) in quote_products.products">
                                    <tr v-if="quote_products.products.length>1" :class="'product_remove_mail_'+index">
                                        <td><b>{{item.product_name}}</b><p v-html="item.description"></p></td>
                                        <td><b>Quantity ({{item.quantity_unit}})</b><br>
                                            <template v-for="(tier, tierIndex) in item.quote_tiers">
                                                <span>{{tier.tier_value}}</span><br>
                                            </template>
                                            <button type="button" @click="removeProduct(item, index)" id="product_mail" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        </td>
                                    </tr>

                                    <tr v-else>
                                        <td><b>{{item.product_name}}</b>
                                            <p v-html="item.description"></p>
                                        </td>
                                        <td><b>Quantity ({{item.quantity_unit}})</b><br>
                                            <template v-for="(tier, tierIndex) in item.quote_tiers">
                                                <span>{{tier.tier_value}}</span><br>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="add-attachment-section">
                    <label>Add Attachment : </label>
                        <div class="add-attachment">
                            <div class="add-attchmnt">

                                <div class="form-group files vendor_mail_files color" >
                                    <vue-dropzone :options="dropzoneOptions"
                                                  :id="'item-dropzone-attach'"
                                                  v-on:vdropzone-sending="sendingEventQuoteAttachments"
                                                  v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>
                        <div class="add-file">
                            <div id="add_vendor_files_attached">
                                <template v-if="form.quote_attachments.length">
                                    <template v-for="(item, index) in form.quote_attachments">
                                        <div v-if="item.image_type=='1'" class="pdf-dwn-sec line-hgt" :class="'vendor_num_'+item.id">
                                            <a class="lightbox" href="javascript:void(0)" @click="imagePreview(item.file_url)">
                                            <img :src="item.file_url" class="quote_image">
                                            </a>
                                            
                                            <a href="javascript:void(0)" v-on:click="download('/quote_files/', item)" class="fa-pull-right download-btn"> <i class="fa fa-download fa-pull-right"></i></a>
                                            {{item.file_name}}<a href="javascript:void(0)" class=" trash_btn" v-on:click="deleteQuoteFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>

                                        </div>

                                        <div v-else class="pdf-dwn-sec line-hgt" :class="'vendor_num_'+item.id">
                                            <span class="file-option-icon"><span class="fa fa-file-pdf"></span></span>{{item.file_name}}

                                            <a href="javascript:void(0)" v-on:click="download('/quote_files/', item)" class="fa-pull-right download-btn"> <i class="fa fa-download fa-pull-right"></i></a>
                                            <a href="javascript:void(0)" class=" trash_btn" v-on:click="deleteQuoteFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                        </div>
                                    </template>
                                </template>

                            </div>
                        </div>
                    </div>

                    <div id="add_vendor_files">
                        <!--<template v-if="vendor_files.length > 0">
                            <template v-for="(item, index) in vendor_files">
                                <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                    <img :src="'/quote_files/'+item.name" style="width:70px;height:70px">
                                    {{item.name}}
                                    <a href="javascript:void(0)" class=" trash_btn" v-on:click="deleteAttachFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                    <a :href="'/quote_files/'+item.name" class=""><i class="fa fa-download fa-pull-right"></i></a>
                                </div>
                            </template>
                        </template>-->
                        <template v-if="vendor_files.length > 0">
                            <template v-for="(item, index) in vendor_files">
                                <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                <a class="lightbox" href="javascript:void(0)" @click="imagePreview(item.src)">
                                <img v-if="item.image_type=='1'" :src="item.src" style="width:70px;height:70px">
                                </a>
                                    
                                    {{item.name}}

                                    <a href="javascript:void(0)" v-on:click="download('/quote_files/', item)" class="pull-right"><i class="fa fa-download fa-pull-right"></i> </a>
                                    <a href="javascript:void(0)" class="trash_btn"
                                       @click="deleteAttachFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                </div>
                            </template>
                        </template>
                    </div>

                    <!--<div class="row">
                        <div class="col-lg-12">
                            <table>
                                <tr>
                                    <td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 1%; padding-right: 1%;line-height: 130%;padding-top: 5px;color: #000000; text-align: left;font-family:'Roboto', sans-serif;">
                                        <table border="0" style="width:100%;border:none;text-align: left;">
                                            <tr>
                                                <td style="width:25%;font-size: 16px; padding:10px; line-height: 10px;">
                                                    <b style="line-height: 20px;display: block;color: #214c87">{{quotationData.user.name}}</b>
                                                    <div
                                                        style="color:#214c87;font-size:12px;font-weight: 300;">{{quotationData.user.title_sign}}</div>
                                                    <img style="width:130px; padding: 2px;"
                                                         :src="asset('/admin/images/pdf_logo.png')"
                                                         alt="logo"/>
                                                    <div
                                                        style="font-size: 15px; padding:5px 0s; line-height: 30px; vertical-align: top;">
                                                        <div
                                                            style="color:#a5b70c; line-height: 30px;font-weight: 600;font-size: 14px;">
                                                            T: {{quotationData.user.contact_no}} <template v-if="quotationData.user.ext!=''">
                                                            Ext. {{quotationData.user.ext}} </template></div>
                                                        <div
                                                            style="color:#a5b70c; line-height: 10px;font-weight: 600;font-size: 14px;padding-bottom: 5px;">
                                                            F: {{quotationData.user.fax}}</div>

                                                        <div
                                                            style="color:#214c87;line-height: 16px;font-size: 14px;font-weight: 600;">
                                                            36 Van Tassel Court
                                                        </div>
                                                        <div
                                                            style="color:#214c87;line-height: 16px;font-size: 14px;font-weight: 600;">
                                                            Hightland Mills, NY 10930
                                                        </div>
                                                        @if($smtp_user)
                                                        <div v-if="quotationData.smtp_user"
                                                             style="color:#214c87;line-height: 20px;font-size: 14px;font-weight: 500;">{{quotationData.smtp_user.smtp_user_name}}</div>

                                                        <div
                                                            style="color:#214c87;line-height: 20px;font-size: 14px;font-weight: 500;text-decoration: underline;">
                                                            www.superbpack.com
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>-->



                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" v-on:click="sendMail">Send Now</button>
                </div>

            </div>
        </div>
        <LightBox :media="previewMedia" :showLightBox="false" :showThumbs="false" ref="lightbox"></LightBox>
        <VendorAddModal @vendorDataSaved="vendorDataSaved"></VendorAddModal>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {debounce} from 'lodash';
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VendorAddModal from "./VendorAddModal";
import InputTag from 'vue-input-tag';
import LightBox from 'vue-it-bigger';

export default {
    name: "SendToVendorModal",
    props: ['quotationData', 'quotation'],
    components: {
        VueTypeaheadBootstrap,
        vueDropzone: vue2Dropzone,
        VendorAddModal,
        InputTag,
        LightBox,
    },
    created() {
        //this.getQuoteDetails();
        this.form.quote_id = this.quotation.id;
    },
    mounted() {
        $(this.$refs.sendToVendorModal).on('show.bs.modal', () => {
            this.getQuoteDetails();
        });
    },
    data() {
        return {
            bus: new Vue(),
            previewMedia: [],
            quote_products: {
                quote_attachments: [],
                products: []
            },
            product_count: null,
            vendors: [],
            vendorData: null,
            systemUsers:[],
            form: {
                quote_id: null,
                vendors: [],
                vendor_id: [],
                quote_subject: null,
                message_body: "Hello, <p>Please quote the below products</p>",
                attached_files: [],
                product_mail_id: [],
                add_cc: [],
                add_ccSystemUsers: [],
                quote_attachments:[]
            },
            isCC: false,
            dropzoneOptions: {
                url: window.route('quote.addAttachments'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 10,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            vendor_files: [],
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            meta_setting: null,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        imagePreview(src, caption = '') {
            this.previewMedia = [{
                thumb: src,
                src: src,
                caption: caption, // Optional
                //srcset: '...' // Optional for displaying responsive images
            }];
            this.$refs.lightbox.showImage(0)
        },
        removeProduct(item, index){
            this.quote_products.products.splice(index, 1);
            this.form.product_mail_id.splice(index, 1);
        },
        deleteQuoteFile(index){
            // this.vendor_files.splice(id, 1);
            this.form.quote_attachments.splice(index, 1);
        },
        deleteAttachFile(index){
            this.vendor_files.splice(index, 1);
            this.form.attached_files.splice(index, 1);
        },
        sendingEventQuoteAttachments(file, xhr, formData){
            // formData.append('quote_id', this.quotation.id);
        },
        afterUploadComplete(file, response) {
            if(response.success==true){
                //console.log(response)
                this.vendor_files.push({
                    name: response.name,
                    size: response.size,
                    src: response.src,
                    image_type: response.image_type,
                    attachment_id: response.attachment_id,
                });
                this.form.attached_files.push(response.name);
            } else {
                this.setErrorMessage('File not uploaded successfully');
            }
        },
        sendMail(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('send_mail_vendors');

            let form = _.cloneDeep(this.form);

            /*form.add_cc = [];
            if(this.form.add_cc != null && this.form.add_cc != "") {
                form.add_cc = this.form.add_cc.split(",");
            }*/

            return axios.post(apiUrl, form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.$emit('vendorEmailSentEvent', data.data);
                        self.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        $('#sendToVendorModal').modal('hide');

                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getQuoteDetails(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('getQuoteDetails');

            return axios.post(apiUrl, {
                quote_id: this.quotation.id
            }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.meta_setting = data.data.meta_setting;
                        this.quote_products = data.data.quote_products;
                        this.product_count = data.data.product_count;

                        if(this.quotation.quote_name != null && this.quotation.quote_name != '') {
                            this.form.quote_subject = this.meta_setting.quote_send_to_vendor_subject.replace("__QUOTE_NUMBER__", `#${this.quotation.quotation_number}`) +" "+this.quotation.quote_name;
                        } else {
                            let subject_html = '';
                            this.quote_products.products.forEach((x) => {
                                subject_html += x.product_name+" ";
                            });
                            this.form.quote_subject = this.meta_setting.quote_send_to_vendor_subject.replace("__QUOTE_NUMBER__", `#${this.quotation.quotation_number}`) +  " "+subject_html;
                        }
                        if(this.meta_setting.quote_send_to_vendor_body) {
                            this.form.message_body = this.meta_setting.quote_send_to_vendor_body.replace("__QUOTE_NUMBER__", `#${this.quotation.quotation_number}`);
                        }

                        this.form.product_mail_id = [];
                        this.quote_products.products.forEach((x) => {
                            this.form.product_mail_id.push(x.product_id);
                        });

                       /* this.quote_products.quote_attachments.forEach((x) => {
                            this.form.attached_files.push(x.file_name);
                        })*/
                        if(this.quote_products.quote_attachments) {
                            this.form.quote_attachments = _.cloneDeep(this.quote_products.quote_attachments);
                        }

                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        vendorDataSaved(vendor) {
            if (vendor) {
                if(!this.form.vendor_id.includes((vendor.id))) {
                    let contacts = vendor.contacts.filter((x) => x.deleted == '0');
                    let email = null;
                    let contact_name = null;
                    let contact_id = '';
                    if(contacts.length) {
                        contact_name = contacts[0].contact_name;
                        email = contacts[0].email;
                        contact_id = contacts[0].id;
                    }
                    let newVendor = {
                        id: `${vendor.id}_${contact_id}`,
                        text: `${contact_name} (${email})`,
                        name: `${contact_name} (${email})`,
                        html: `<div>${contact_name} (${email})</div><div class="short_text"><label id="company_name"><b>${vendor.company_name}</b></label></div>`,
                    }

                    //this.form.quote_subject = this.form.quote_subject.replace('__VENDOR_NAME__', contact_name).replace('__VENDOR_COMPANY_NAME__', vendor.company_name);
                    //this.form.quote_subject = this.form.quote_subject.replace('()', '');
                    //this.form.message_body = this.form.message_body.replace('__VENDOR_NAME__', contact_name).replace('__VENDOR_COMPANY_NAME__', vendor.company_name);
                    //this.form.message_body = this.form.message_body.replace('()', '');

                    this.form.vendors.push(newVendor);
                    this.form.vendor_id.push(newVendor.id);
                }
            }
            $('#vendorAddModal').modal('hide');
        },
        onVendorSelect(event){
            //console.log(event)
            this.form.vendor_id = [];
            if (event.length) {
                event.forEach((item) => {
                    if(!this.form.vendor_id.includes((item.id))) {
                        this.form.vendor_id.push(item.id);
                    }
                });
            }

            if(this.form.vendor_id.length) {
                let vendor = this.vendors.find((x) => x.id == this.form.vendor_id[0]);

                //console.log(vendor)

                if(vendor) {
                    let contact_name = vendor.contact_name;
                    let company_name = vendor.contact_email;

                    //this.form.quote_subject = this.form.quote_subject.replace('__VENDOR_NAME__', contact_name).replace('__VENDOR_COMPANY_NAME__', company_name)
                    //this.form.quote_subject = this.form.quote_subject.replace('()', '');
                    //this.form.message_body = this.form.message_body.replace('__VENDOR_NAME__', contact_name).replace('__VENDOR_COMPANY_NAME__', company_name);
                    //this.form.message_body = this.form.message_body.replace('()', '');
                }
            }
        },
        onVendorDeSelect(event){
            this.form.vendor_id = [];
            if (event.length) {
                event.forEach((item) => {
                    if(!this.form.vendor_id.includes((item.id))) {
                        this.form.vendor_id.push(item.id);
                    }
                });
            }
        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendorNew(loading, search, this);
            }
        },
        searchVendorNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchVendors'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.vendors = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),

        onSystemUserSelect(event){
            //console.log(event)
            this.form.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    let email = item.email ? item.email : item.text;
                    if(!this.form.add_cc.includes((email))) {
                        this.form.add_cc.push(email);
                    }
                });
            }
        },
        onSystemUserDeSelect(event){
            this.form.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    let email = item.email ? item.email : item.text;
                    if(!this.form.add_cc.includes((email))) {
                        this.form.add_cc.push(email);
                    }
                });
            }
        },
        addCustomCC(email) {
            const regexExp =  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if(email.match(regexExp) && email.includes(".com") && this.systemUsers.length > 0) {
                console.log(email)

                if(!this.form.add_cc.includes(email.trim())) {
                    this.form.add_cc.push(email.trim());
                    this.form.add_ccSystemUsers.push({
                        email:email.trim(),
                        html:email.trim(),
                        id:email.trim(),
                        text:email.trim(),
                    });
                }

            }
        },
        onSystemUserSearch(search, loading) {
            if(search.length) {
                if(this.systemUsers.length == 0) {
                    loading(true);
                    this.searchSystemUser(loading, search, this);
                }

            }
        },
        searchSystemUser: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchSaleUser'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.systemUsers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        download(path, attach) {
            /*let url = window.route('quotations.download', {
                id: attach.id,
                path: 'quote_files',
                name: attach.file_name
            });*/

           // let url = '/quote_files/' + attach.file_name;

            let url = window.route('quotations.downloadFile', {
                id: attach.id,
               // path: 'public/quote_files/',
              //  name: attach.file_name
            });



            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url,  {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        // Service that handles ajax call
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", attach.file_name);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
